module.exports = __webpack_public_path__ + "img/stack03.a92d3235.svg";